import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { AddPaymentAccountComponent } from './add-payment-account/add-payment-account.component';
import { PaymentAccountDetailsComponent } from './payment-account-details/payment-account-details.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    CreditCardDirectivesModule,
    UzurvDirectivesModule,
    UzurvPipesModule
  ],
  declarations: [PaymentAccountDetailsComponent, AddPaymentAccountComponent],
  exports: [PaymentAccountDetailsComponent, AddPaymentAccountComponent]
})
export class PaymentAccountModule {}
